<app-page-wrapper classname="character-creation">

  <app-responsive-popup [caption]="audio.text.createAvatar.chooseYourAvatar" [headerDecoration]="true">
    <div class="question">{{audio.text.createAvatar.remarks}}</div>

    <div class="columns">

      <div class="column-left">

        <div class="column-content column-content-left">

          <div class="avatar-list-wrapper" *ngFor="let settingConfig of settings" #settingSelector
            [id]="'settingSelector' + settingConfig.name">

            <div class="avatar-button avatar-button-left">
              <img src="/img/createavatar/pijl_links.svg" class="arrow"
                (click)="prev(settingConfig); audio.playSoundClick();">
            </div>
            <div class="list-box">
              <div class="scrollable-list">

                <div class="item" *ngFor="let settingValue of settingConfig.values">
                  <img [src]="'/img/createavatar/' + settingConfig.name + '_' + settingValue.name + '.svg'" (load)="updateAvatar()"
                    alt="{{audio.text.createAvatar.skinLight}}">
                </div>
              </div>
            </div>
            <div class="avatar-button avatar-button-right"><img src="/img/createavatar/pijl_rechts.svg" class="arrow"
                (click)="next(settingConfig); audio.playSoundClick();">
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>


      <div class="column-right">
        <div class="column-content">

          <div class="avatar-wrapper">
            <div class="avatar-holder">
              <img id="selectedAvatarImage" [src]="activeImageUrl">
            </div>

            <div class="username">{{username}}</div>
            <app-button-next3 [disabled]="sending"  (clicked)="btnContinueClicked()">{{audio.text.global.continue}}</app-button-next3>
          </div>

        </div>
      </div>
    </div>
  </app-responsive-popup>
</app-page-wrapper>
